module.exports = __webpack_public_path__ + "static/media/content-distribution-icon.4c2ecbab.svg";